module.exports = __webpack_public_path__ + "media/images/profile-564d45a374b1fe4627cbb04a43dbb541.png";